import React from 'react';
import NextErrorComponent from 'next/error';
import * as Sentry from '@sentry/nextjs';

import Page404 from '@components/Page404';
import Logger from '@utils/Logger';

function Error() {
  return <Page404 />;
}

Error.getInitialProps = async ({ res, err, asPath }) => {
  const errorInitialProps = await NextErrorComponent.getInitialProps({
    res,
    err
  });

  errorInitialProps.hasGetInitialPropsRun = true;

  if (res?.statusCode === 404) {
    // Opinionated: do not record an exception in Sentry for 404
    return { statusCode: 404 };
  }

  if (err) {
    Sentry.captureException(err);
    const sentryRes = await Sentry.flush(2000);
    Logger.log(sentryRes);
    return errorInitialProps;
  }

  // If this point is reached, getInitialProps was called without any
  // information about what the error might be. This is unexpected and may
  // indicate a bug introduced in Next.js, so record it in Sentry
  Sentry.captureException(
    new Error(`_error.js getInitialProps missing data at path: ${asPath}`)
  );
  const sentryRes = await Sentry.flush(2000);
  Logger.log(sentryRes);

  return errorInitialProps;
};

export default Error;
